// src/services/auth.ts
import { fetchUtils } from 'react-admin';


const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';

function getAuthHeaders() {
  const headers = new Headers({ Accept: 'application/json' });
  const authToken = localStorage.getItem('session') || localStorage.getItem('token');
  if (authToken) headers.set('Authorization', `Bearer ${authToken}`);
  return headers;
}

// Try to obtain userId from backend endpoints. Returns userId string or null.
export async function fetchUserIdFromServer(): Promise<string | null> {
  const endpoints = [`${apiUrl}/auth/current-user-id`];
  for (const ep of endpoints) {
    try {
      const resp = await fetchUtils.fetchJson(`${ep}`, { headers: getAuthHeaders() });
      const data = resp.json;
      // try common locations
      const id = data?.id || data?.userId || data?.user?.id || data?.data?.id || data?.sub;
      if (id) {
        localStorage.setItem('userId', String(id));
        return String(id);
      }
      // some endpoints may return { user: { id, ... } }
      if (data?.user && (data.user.id || data.user.userId)) {
        const uid = data.user.id || data.user.userId;
        localStorage.setItem('userId', String(uid));
        return String(uid);
      }
    } catch (e) {
      // ignore and try next
    }
  }
  return null;
}

// Call backend endpoint that directly returns current role id
export async function fetchCurrentRoleIdFromServer(): Promise<string | null> {
  try {
    const resp = await fetchUtils.fetchJson(`${apiUrl}/auth/current-role-id`, { headers: getAuthHeaders() });
    const data = resp.json;
    const roleId = data?.roleId || data?.id || data?.data?.roleId || data?.data?.id || data?.role?.id;
    if (roleId) return String(roleId);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('fetchCurrentRoleIdFromServer failed', e);
  }
  return null;
}
